import React from 'react'
import './reports.css'
import ReportPage from '../../components/Reports/ReportPage'

const ReportsMainPage = () => {
  return (
    <div>
      <ReportPage/>
    </div>
  )
}

export default ReportsMainPage
